<template>
  <div
    class="depart-member"
    :style="{width: width + 'px'}"
  >
    <div class="depart-member-content">
      <div
        v-loading="!show"
        class="select-list"
      >
        <div
          v-if="show"
          class="select-list-header"
        >
          <mk-input
            v-model="filterText"
            class="search"
            placeholder="搜索"
            height="24"
            clearable
          ></mk-input>
        </div>
        <div
          v-if="show"
          class="select-list-content"
        >
          <mk-tree
            ref="tree"
            class="mk-trees"
            :class="{'hide-root-node-checkbox': !canSelectCompany}"
            :data="list"
            :default-checked-keys="checkedKeys"
            :show-checkbox="!isSingle"
            highlight-current
            :filter-node-method="filterNode"
            node-key="id"
            :check-strictly="true"
            :props="defaultProps"
            @check="checkChange"
          >
            <span
              slot-scope="{ node, data }"
              class="custom-tree-node"
            >
              <ds-iconfont
                v-if="!data.userId"
                icon-class="file-icon iconxuanzekaitongrenyuan-weixuanzhong"
              />
              <label :for="data.id">
                <input
                  v-if="data.userId && isSingle"
                  :id="data.id"
                  v-model="singleMember"
                  type="radio"
                  :value="data.id"
                  :name="data.name"
                  @change="change"
                />
                <span
                  class="txt"
                  :title="data.name"
                >{{ data.name }}</span>
              </label>
            </span>
          </mk-tree>
        </div>
      </div>
      <div class="select-has-been">
        <div class="select-has-been-header">
          <span>已选择的{{ (isSingle || !canSelectDept) ? '' : '部门或' }}成员</span>
          <ul
            ref="activeList"
          >
            <li
              v-for="(item,index) in checkedList"
              :key="item.id + '_' + index"
            >
              <template v-if="compareShow(item,checkedList)">
                <div
                  :id="'tree-active-'+item.id"
                  ref="activeItem"
                  :class="{'is-dept': !item.userId}"
                  :data-name="item.name"
                >
                  <ds-iconfont
                    v-if="!item.userId"
                    icon-class="file-icon iconxuanzekaitongrenyuan-weixuanzhong"
                  />
                  <span class="ic">{{ item.name }}</span>
                </div>
                <i
                  class="el-icon-close"
                  @click="remove"
                ></i>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="handle">
      <mk-button-biz
        width="56px"
        height="24px"
        font-size="12px"
        @click="cancel"
      >
        取消
      </mk-button-biz>
      <mk-button-biz
        class="confirm"
        type="primary"
        width="56px"
        height="24px"
        font-size="12px"
        @click="confirm"
      >
        确认
      </mk-button-biz>
    </div>
  </div>
</template>
<script>
function unique (arr) {
  for (var i = 0; i < arr.length; i++) {
    for (var j = i + 1; j < arr.length; j++) {
      if (arr[i].userId === arr[j].userId) { // 第一个等同于第二个，splice方法删除第二个
        arr.splice(j, 1)
        j--
      }
    }
  }
  return arr
}
export default {
  name: 'DeptMember',
  props: {
    canSelectCompany: {
      // 公司是否可选
      type: Boolean,
      default: false
    },
    isSingle: {
      // 是否选择了单人
      type: Boolean,
      default: false
    },
    canSelectDept: {
      // 精确到人是否为多选
      type: Boolean,
      default: true
    },
    initMemberList: {
      type: Array,
      default () {
        return []
      }
    },
    initDeptList: {
      type: Array,
      default () {
        return []
      }
    },
    initAllDept: {
      type: Array,
      default () {
        return []
      }
    },
    initAllMember: {
      type: Array,
      default () {
        return []
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 420
    },
    useSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      list: [],
      handleList: [], // 处理多人选择列表
      checkedList: [], // 被选中列表
      activeList: [],
      isRemoving: false, // 正在移除
      checkedKeys: [], // 选中的key数组
      singleMember: '' // 单选时的值
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    },
    show (val) {
      if (val && !this.useSelect) {
        this.init()
        this.getAllDepartments()
      }
    }
  },
  created () {
    this.init()
    this.getAllDepartments()
  },
  methods: {
    init () {
      this.checkedList = this.initMemberList.concat(this.initDeptList)
      let arr = []
      this.checkedList.forEach((item, index) => {
        if (this.isSingle || !this.canSelectDept) {
          item.userId = item.id
        }
        arr[index] = item.id
      })
      this.checkedKeys = arr
      this.checkedList = this.checkedList.concat([])
    },
    updateData () {
      this.init()
      // start
      let list = this.$refs.activeList.getElementsByTagName('li')
      list.forEach((item, index) => {
        item.style.display = 'flex'
      })
      // end
      // select展开时，获取初始数据
      this.getAllDepartments()
    },
    change (e) {
      // 单选change事件
      this.checkedList = [{
        id: e.target.id,
        userId: e.target.id,
        name: e.target.name
      }]
    },
    confirm () {
      let list = this.$refs.activeList.getElementsByTagName('li')
      let selectedDeptList = [] // 选中部门列表
      let selectedMemberList = [] // 选中成员列表
      // let keys = []
      list.forEach((item, index) => {
        if (item.style.display !== 'none') {
          if (item.getElementsByTagName('div')[0]) {
            let id = item
              .getElementsByTagName('div')[0]
              .id.split('tree-active-')[1]
            if (item.getElementsByTagName('div')[0].className.indexOf('is-dept') >= 0) {
              // keys.push(id)
              selectedDeptList.push({
                id: id,
                name: item
                  .getElementsByTagName('div')[0]
                  .getAttribute('data-name')
              })
            } else {
              // keys.push(id)
              selectedMemberList.push({
                id: id,
                name: item
                  .getElementsByTagName('div')[0]
                  .getAttribute('data-name')
              })
            }
          }
        }
      })
      this.filterText = ''
      // this.checkedKeys = keys
      this.$emit('confirm', {
        dept: selectedDeptList,
        member: selectedMemberList
      })
    },
    // 取消
    cancel () {
      this.filterText = ''
      // this.checkedKeys = []
      this.$emit('cancel')
    },
    // 过滤筛选
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    remove (el) {
      if (this.isSingle && !this.canSelectDept) {
        this.checkedList = []
        this.$refs.tree.setCheckedNodes([])
      } else {
        // 这里不能移除节点，否则需保存2份数据，否则取消时无法还原数据
        el.target.parentNode.style.display = 'none'
        let list = this.$refs.activeList.getElementsByTagName('li')
        let arr = []
        list.forEach((item, index) => {
          if (item.style.display !== 'none') {
            if (item.getElementsByTagName('div')[0]) {
              let id = item
                .getElementsByTagName('div')[0]
                .id.split('tree-active-')[1]
              if (Number(id) > 0) {
                arr[index] = {
                  id: Number(id)
                }
              } else {
                arr[index] = {
                  id: id
                }
              }
            }
          }
        })
        if (this.show) {
          this.$refs.tree.setCheckedNodes(arr)
        }
      }
    },
    checkChange (data) {
      if (this.isSingle && !this.canSelectDept) {
        // 单选不能添加部门
        if (data.children) {
          return
        }
        let arr = [
          {
            id: data.userId,
            name: data.name
          }
        ]
        this.$refs.tree.setCheckedNodes(arr)
        this.checkedList = arr
      } else {
        let arr = this.$refs.tree.getCheckedNodes()
        let newArr = []
        arr.forEach(item => {
          if (this.canSelectCompany) {
            if (document.getElementById('tree-active-' + item.id)) {
              document.getElementById('tree-active-' + item.id).parentNode.style.display = 'flex'
            }
            newArr.push(item)
          } else {
            if (item.id !== 'NA') {
              if (document.getElementById('tree-active-' + item.id)) {
                document.getElementById('tree-active-' + item.id).parentNode.style.display = 'flex'
              }
              newArr.push(item)
            }
          }
        })
        this.checkedList = newArr
      }
    },
    compareShow (item, arr) {
      // 比较是否显示改已选中节点
      // 注意：同一个人可能存在于多个部门
      if (this.isSingle) {
        return true
      } else if (!this.canSelectDept) {
        let show = true
        item.userId ? show = true : show = false
        return show
      } else {
        let show = true
        if (arr instanceof Array) {
          arr.forEach((itemB, indexB) => {
            if (item.departmentId instanceof Array) {
              item.departmentId.forEach((itemC, indexC) => {
                if (itemC === itemB.id) {
                  show = false
                }
              })
            } else {
              if (item.departmentId === itemB.id) {
                show = false
              }
            }
            if (item.parentId === itemB.id) {
              show = false
            }
          })
        }
        return show
      }
    },
    // 获取所有的部门
    getAllDepartments () {
      let deptList = this.initAllDept
      let memberList = this.initAllMember
      let arr = []

      memberList.forEach((item, index) => {
        arr[index] = {
          ...item,
          id: item.userId
        }
      })
      this.handleInitList(deptList, arr)
    },
    handleInitList (deptList, memberList) {
      const accountName = JSON.parse(window.localStorage.getItem('user')).accountName
      this.list = [
        {
          id: 'NA',
          name: accountName,
          // parentId: 'NA',
          parentId: '',
          level: 0,
          children: []
        }
      ]
      let NAList = []
      // 将成员添加到对应的部门下
      deptList.forEach((item, index) => {
        item.children = []
        if (this.isSingle || !this.canSelectDept) {
          item.disabled = true
        }
        memberList.forEach(itemC => {
          if (itemC.departmentId instanceof Array) {
            // 一个成员可能存在于多个部门
            itemC.departmentId.forEach(itemB => {
              if (itemB === item.id) {
                item.children.push(itemC)
              }
            })
          } else {
            if (itemC.departmentId === item.id) {
              item.children.push(itemC)
            }
            if (itemC.departmentId === 'NA') {
              NAList.push(itemC)
              unique(NAList)
            }
          }
        })
      })
      this.list[0].children = NAList
      this.handleList = deptList

      this.handleArr(this.list, this.handleList)
    },
    handleArr (list, handleList) {
      handleList.forEach((item, index) => {
        if (list instanceof Array) {
          list.forEach((itemC, indexC) => {
            if (item.id !== 'NA' && item.parentId === itemC.id) {
              itemC.children.push({
                children: [],
                ...item
              })
            }
            if (index === handleList.length - 1) {
              this.handleArr(itemC.children, this.handleList)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.depart-member {
  width: 100%;
  min-width: 420px;
  // height: 386px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  position: relative;
  z-index: 2002;
  cursor: pointer;

  input[type='radio'] {
    -webkit-appearance: none;
    vertical-align: middle;
    background: #fff;
    border: #d1d1d1 solid 1px;
    border-radius: 100%;
    width: 16px;
    height: 16px;
    position: relative;
    // border-color: #009cff;
    box-sizing: border-box;
    flex-shrink: 0;
    cursor: pointer;
    margin-right: 4px;
  }

  input[type='radio']:checked {
    border-color: #009cff;
  }

  input[type='radio']:focus {
    outline: none;
  }

  input[type='radio']:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #009cff;
  }

  /deep/ .el-tree {
    .el-tree-node {
      position: absolute;
      min-width: 209.5px;
      width: 100%;
    }

    .el-tree-node__children {
      .el-tree-node {
        position: relative !important;
      }
    }

    .file-icon {
      color: #8f9fb3;
      font-size: 14px;
      margin-right: 2px;
    }

    .txt {
      font-size: 12px;
      padding-right: 4px;
    }
  }

  label {
    cursor: pointer;
  }

  .select-list-content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .select-list-content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #d9d9d9;
  }

  .select-list-content::-webkit-scrollbar-track {
    background: #fff;
  }

  .depart-member-content {
    display: flex;
    width: 100%;
    height: 342px;
    box-sizing: border-box;
    border-bottom: 1px solid #f5f5f5;

    .select-list {
      flex: 1;
      max-width: 50%;
      overflow: hidden;
      border-right: 1px solid #f5f5f5;

      .select-list-header {
        overflow: hidden;
        display: flex;
        height: 36px;
        // justify-content: center;
        border-bottom: 1px solid #f5f5f5;
        position: relative;

        .search {
          width: calc(100% - 30px);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .select-list-content {
        width: 100%;
        height: calc(100% - 36px);
        overflow: auto;
        box-sizing: border-box;
        border-bottom: 1px solid #f5f5f5;

        // /deep/ .el-tree {
        //   .file-icon {
        //     color: #8f9fb3;
        //     font-size: 14px;
        //     margin-right: 2px;
        //   }

        //   .txt {
        //     font-size: 12px;
        //     padding-right: 4px;
        //   }
        // }
      }
    }

    .select-has-been {
      flex: 1;
      max-width: 50%;

      .select-has-been-header {
        height: 36px;
        border-bottom: 1px solid #f5f5f5;

        span {
          color: #a1a1a1;
          font-size: 13px;
          line-height: 36px;
          margin-left: 10px;
        }
      }

      ul {
        width: 100%;
        height: 301px;
        overflow-y: auto;

        li {
          line-height: 40px;
          font-size: 13px;
          color: #595959;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .file-icon {
            font-size: 14px;
            // margin-right: -10px;
            margin-right: 4px;
            color: #8f9fb3;
          }

          span.ic {
            margin-left: 0;
          }

          .el-icon-close {
            color: #595959;
            font-size: 14px;
            cursor: pointer;
          }
        }

        li:hover {
          background-color: #f5f5f5;
          cursor: pointer;
        }
      }
    }
  }

  .handle {
    height: 44px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .confirm {
      margin-right: 10px;
    }
  }

  .hide-root-node-checkbox {
    /deep/ .el-tree-node__content .el-checkbox {
      display: none;
    }
    // /deep/ .el-tree-node__children .el-tree-node__content .el-checkbox {
    //   display: block;
    // }
  }

  /deep/ .el-checkbox.is-disabled {
    display: none !important;
  }

  .mk-trees {
    /deep/ .el-tree-node__children .el-tree-node__content .el-checkbox {
      display: block;
    }
  }
}
</style>
